import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { useCreate, useDelete, useGetAll, useGetOne, useUpdate } from "./crudService";
import { isConductor } from "@utils/tenant";

const endpoint:string = isConductor ? 'conductor-reports' : 'reports';

export function useGetAllReports(params:{page:number}, queryParams:any = {}) {
    return useGetAll({queryKey: [endpoint], ...queryParams}, params);
}

export function useGetReport(id: number, queryParams:any = {}) {
    return useGetOne({queryKey: [endpoint, id], ...queryParams});
}

export function useCreateReport() {
    return useCreate({queryKey: [endpoint]});
}

export function useUpdateReport({id}) {
    return useUpdate({queryKey: [endpoint, id]});
}

export function useDeleteReport({id}) {
    return useDelete({queryKey: [endpoint, id]});
}
